import React from "react";
import Questionnaire from "./Questionnaire/Questionnaire";
import Button from '../../partials/Button'

import styles from "./Interaction8.module.scss";
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
// Some fixes on branch scenario 8
export default function Interaction8(props) {
  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
      <div className="back-btn-container">
        <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
      </div>
      <Questionnaire
        finalPopupData={props.data.finalPopup}
        onComplete={props.onComplete}
        questions={props.data.questions}
        initialMeters={props.data.meters}
        instructions={props.data.intro.body}
      />
    </InteractionContainer>
  );
}
